import { ApiClient } from '../../../../../core/services/api.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../core/services/api.service";
export class FeatureService {
    constructor(http) {
        this.http = http;
        this.apiSegment = 'users';
    }
    all() {
        return this.http.get(`${this.apiSegment}`);
    }
    create(data) {
        return this.http.post(`${this.apiSegment}`, data);
    }
    item(id) {
        return this.http.get(`${this.apiSegment}/${id}`);
    }
    update(id, data) {
        if (data instanceof FormData) {
            data.append('_method', 'PUT');
        }
        else {
            data = Object.assign({}, data, { '_method': 'PUT' });
        }
        return this.http.post(`${this.apiSegment}/${id}`, data);
    }
    patch(id, data) {
        if (data instanceof FormData) {
            data.append('_method', 'PATCH');
        }
        else {
            data = Object.assign({}, data, { '_method': 'PATCH' });
        }
        return this.http.post(`${this.apiSegment}/${id}`, data);
    }
    config(id, data) {
        data = Object.assign({}, data, { '_method': 'put' });
        return this.http.post(`${this.apiSegment}/${id}/config`, data);
    }
    delete(id) {
        return this.http.delete(`${this.apiSegment}/${id}`);
    }
}
FeatureService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureService_Factory() { return new FeatureService(i0.ɵɵinject(i1.ApiClient)); }, token: FeatureService, providedIn: "root" });
